export const HEIGHT_BUFFER = 10;
